import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'
import CategoryDescription from '../components/category-description';
import Navigation from '../components/navigation.js'
import { graphql } from 'gatsby';
const _ = require('lodash');

const IndexPage = ({ data, pageContext }) => (
    <Layout>
        <SEO title="Podcast" keywords={['podcast', 'list']} />
        <h1>
            Podcasts
        </h1>
        {data.allMarkdownRemark.edges.map(({ node }) => 
            <div key={node.id}>
                <CategoryDescription
                    titlepost={node.frontmatter.title}
                    excerpt={node.excerpt}
                    slug={`/${_.kebabCase(node.frontmatter.title)}`}
                    image={node.frontmatter.image.childImageSharp.fixed.src}
                    podcast={node.frontmatter.podcast}
                    langKey={node.frontmatter.langKey}
                />
                <hr />
            </div>
        )}

        <Navigation 
            pageContext={pageContext}
            totalCount={data.allMarkdownRemark.totalCount}
        />
    </Layout>
)

export default IndexPage

export const query = graphql`
    query IndexQueryPodcast($skip: Int, $limit: Int) {
        allMarkdownRemark(
            skip: $skip
            limit: $limit
            filter: { 
                frontmatter: { 
                    category: { 
                        eq: "category"
                    } 
                    podcast: {
                        eq: true
                    }
                } 
            }
            sort: {
                fields: [frontmatter___date], order: DESC
            }
        ) {
            totalCount
            edges {
                node {
                    id
                    frontmatter {
                        title
                        image {                      
                            childImageSharp {
                                fixed(width: 150, height:150) {
                                    src
                                }
                            }
                        }
                        podcast
                        langKey
                    }
                    fields {
                        slug
                    }
                    excerpt
                }
            }
        }
    }
`
